import {atom} from "recoil";

export const changeRequestToggleState = atom<boolean>({
  key: "changeRequestState",
  default: false,
});
